import { render, staticRenderFns } from "./ProblemDetails.vue?vue&type=template&id=52b368f2&"
import script from "./ProblemDetails.vue?vue&type=script&lang=js&"
export * from "./ProblemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports